import { useCurrenciesStore } from '@/stores';
import { computed } from 'vue';
import { useToast } from 'primevue/usetoast';
export function useCurrencies() {
    const currenciesStore = useCurrenciesStore();
    const currencies = computed(() => currenciesStore.currencies);
    const loadingFlag = computed(() => currenciesStore.loadingFlag);
    const toast = useToast();
    const toastText = 'get_currencies';
    const toGetCurrencies = async () => {
        try {
            await currenciesStore.awaitGetCurrencies();
        } catch (error) {
            toast.add({ severity: 'error', group: 'global', summary: toastText, detail: error, life: 4000 });
        }
    };
    return {
        loadingFlag,
        currencies,
        toGetCurrencies
    };
}
